module.exports = __webpack_public_path__ + "static/img/fixiphonesix.14714bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fixiphonesix.png
// module id = 8LPU
// module chunks = 0